<div class="footer-container mt-sm-1 mt-md-3">
  Copyright © {{current_year}} PayArc - All rights Reserved | <a class="privacy" target="_blank" href="https://www.payarc.com/privacy-policy">Privacy</a>
</div>
